import { Injectable } from '@angular/core';
import {catchError, tap} from "rxjs/operators";
import {Observable, Subject, throwError} from "rxjs";
import {HttpClient, HttpErrorResponse, HttpHeaders} from "@angular/common/http";
import {Router} from "@angular/router";
import {environment} from "../../environments/environment";
import {Operation, ReqByPhoneComplete, ReqLoginByPassword, ReqRegisterComplete} from "../models/auth.model";
import { AppVersionService } from './app-version.service';

@Injectable({
  providedIn: 'root'
})
export class AuthService {
  public error$: Subject<string> = new Subject<string>();
  public isAuthenticated$: Subject<boolean> = new Subject<boolean>();
  public defaultPage = 'search';

  constructor(
    private readonly http: HttpClient,
    private readonly appVersion: AppVersionService,
    private readonly router: Router) { }

  get accessToken(): any {
    const authInfo = localStorage.getItem('authInfo');
    if (authInfo) {
      return JSON.parse(authInfo)?.value?.accessToken;
    } return null;
  }
  get token(): any {
    const authInfo = localStorage.getItem('authInfo');
    if (authInfo) {
      return JSON.parse(authInfo)?.value?.token;
    } return null;
  }
  get authInfo(): any {
    const authInfo = localStorage.getItem('authInfo');
    if (authInfo) {
      return JSON.parse(authInfo);
    } return null;
  }
  get isAuthenticated(): boolean {
    return !!this.accessToken;
  }

  // Аутентификация по паролю.
  loginByPassword(req: ReqLoginByPassword): Observable<any> {
    const url = `${environment.apiUrl}v1/auth/login`
    const headers = new HttpHeaders({ 'X-AppVersion': this.appVersion.appVersion });
    return this.http.post(url, req, { headers }).pipe(tap(this.setToken), catchError(this.handleError.bind(this)));
  }

  // Аутентификация/Регистрация по коду в SMS.
  loginOrRegistrationBySms(operation: Operation, phone: string): Observable<any> {
    const url = `${environment.apiUrl}v1/auth/${operation}`
    const headers = new HttpHeaders({ 'X-AppVersion': this.appVersion.appVersion });
    return this.http.post(url, { phone: phone }, { headers }).pipe(tap(this.setToken), catchError(this.handleError.bind(this)));
  }

  // Завершение аутентификации по коду в SMS.
  byPhoneComplete(req: ReqByPhoneComplete): Observable<any> {
    const url = `${environment.apiUrl}v1/auth/by-phone-complete`
    const headers = new HttpHeaders({ 'X-AppVersion': this.appVersion.appVersion });
    return this.http.post(url, req, { headers }).pipe(tap(this.setToken), catchError(this.handleError.bind(this)));
  }

  // Завершение регистрации по коду в SMS.
  registerComplete(req: ReqRegisterComplete): Observable<any> {
    const url = `${environment.apiUrl}v1/auth/register-complete`
    const headers = new HttpHeaders({ 'X-AppVersion': this.appVersion.appVersion });
    return this.http.post(url, req, { headers }).pipe(tap(this.setToken), catchError(this.handleError.bind(this)));
  }

  logout(): void {
    this.setToken(null);
    this.isAuthenticated$.next(this.isAuthenticated);
    this.router.navigate(['/login'], {
      queryParams: {
        loginAgain: true
      }
    }).then(() => {
      location.reload();
    });
  }

  private handleError(error: HttpErrorResponse): any {
    switch (error.status) {
      case 401:
        this.error$.next('Неверный логин или пароль');
        break;
    }
    return throwError(error);
  }
  private setToken(response: any | null): any {
    if (response) {
      if (response.hasOwnProperty('value'))
        localStorage.setItem('authInfo', JSON.stringify(response));
    } else {
      localStorage.clear();
    }
  }
}
